import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CustomFieldsModalContent from '@components/show_page/bulk_actions/sub_components/CustomFieldsModalContent';
import TagsModalContent from '@components/show_page/bulk_actions/sub_components/TagsModalContent';

import renderModal from '../modals/renderModal';

const BulkTagWrapper = (props) => {
  const [showCustomFields, toggleCustomFields] = useState(false);

  useEffect(() => (
    () => { props.closeModal(); }
  ), []);

  const hasCustomFields = BFG.context.hasFeature('custom_fields');

  return (
    <div className="bulk-tag-wrapper">
      <div className="modal-content-wrapper__header wrapper-headers">
        <div
          className={`header ${!showCustomFields ? "active" : ''} ${!hasCustomFields ? 'one-tab' : ''}`}
          onClick={() => toggleCustomFields(false)}
        >
          <span className="bff-tag icon" aria-hidden="true" />
          <h3 className="modal-title">{t('Bulk Tag')}</h3>
        </div>
        {hasCustomFields && (
          <div
            className={`header ${showCustomFields && "active"}`}
            onClick={() => toggleCustomFields(true)}
          >
            <span className="bff-custom-fields icon" aria-hidden="true" />
            <h3 className="modal-title">{t('Bulk Custom Fields')}</h3>
          </div>
        )}
      </div>
      {showCustomFields
        ? <CustomFieldsModalContent {...props} />
        : <TagsModalContent {...props} />
      }
    </div>
  );
};

BulkTagWrapper.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const ModalComponent = renderModal(BulkTagWrapper, 'BulkTagWrapper');
export default ModalComponent;
